import { combineReducers } from 'redux'
import view from './view'
import settings from './settings'
import lists from './lists'
import cards from './cards'
import dates from './dates'
import activities from './activities'
import owners from './owners'
import visitors from './visitors'
import listsMode from './listsMode'
import calendar from './calendar'

export default combineReducers({
  view,
  settings,
  lists,
  cards,
  dates,
  activities,
  owners,
  visitors,
  listsMode,
  calendar
})
